<template>
  <div class="wrapper wrapper-content  animated fadeInRight">
    <div class="ibox">
      <div class="ibox-title">
        <h5>Build Flow</h5>
        <button class="btn btn-xs btn-success pull-right m-l-xs" @click="copyBadARecords" v-if="user.admin">Copy bad A Records</button>
        <router-link to="/pbn/builds/report" class="btn btn-xs btn-primary pull-right" v-if="user.admin">Report</router-link>
      </div>
      <div class="ibox-content col-lg-12">
        <filters></filters>
        <div class="col-lg-12 m-t-sm"></div>
        <list></list>
      </div>
    </div>
  </div>
</template>
<script>
import Filters from './Build/Filters'
import List from './Build/List'
import { mapGetters } from 'vuex'
import { Browser } from '../../../mixins/helperMixin'

export default {
  components: {
    filters: Filters,
    list: List
  },
  computed: {
    ...mapGetters({
      user: 'getUser',
      sites: 'getPbns'
    })
  },
  mixins: [Browser],
  mounted () {
    document.title = 'Builds :: PBN360 by Aphex Media'
  },
  methods: {
    copyBadARecords () {
      let badies = ''
      this.sites.forEach(s => {
        if (s.integrations && s.integrations.hosting && s.integrations.hosting.ip && !s.dnsHostingMatches) {
          badies += `${s.domain} ${s.integrations.hosting.ip.ip_address}\n`
        }
      })
      this.copyToClipboard(badies)
      this.$toastr.success('IPs and domains copied to clipboard')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Pbn/Builds.vue